import { AvTimer, Check } from '@mui/icons-material'
import { Box } from '@mui/material'
import { ERROR_COLORS, GRAY_COLORS, INFO_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { CheckCircleIcon } from 'asterX-UI/Icons'
import { AlertCircleIcon } from 'asterX-UI/Icons/AlertCircleIcon'
import { ArrowCircleBrokenRight } from 'asterX-UI/Icons/ArrowCircleBrokenRight'
import { CalendarCheck } from 'asterX-UI/Icons/CalendarCheck'
import { CarIcon } from 'asterX-UI/Icons/CarIcon'
import { FileIcon5 } from 'asterX-UI/Icons/FileIcon5'
import { FlipBackward } from 'asterX-UI/Icons/FlipBackward'
import { SlashCircleIcon } from 'asterX-UI/Icons/SlashCircleIcon'
import { SwitchHorizontal } from 'asterX-UI/Icons/SwitchHorizontal'

export const baseIconStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '12px',
  borderRadius: '50%'
}

export const MODAL_CONFIG = {
  UPLOAD_PAYMENT_ORDER: {
    headTitle: 'Загрузите платежное поручение',
    title: '',
    subtitle: 'Для выдачи кредита , необходимо загрузить платежное поручение из банк клиента',
    labelConfirm: 'Загрузить',
    color: 'primary'
  },
  CREATE_DDS: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FileIcon5 />
      </Box>
    ),
    title: 'Создать ДДС',
    subtitle: '',
    labelConfirm: 'Создать',
    color: 'primary',
    maxWidth: 'md'
  },
  UPDATE_DDS: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FileIcon5 />
      </Box>
    ),
    title: 'Обновить ДДС',
    subtitle: '',
    labelConfirm: 'Обновить',
    color: 'primary',
    maxWidth: 'md'
  },
  CREATE_DDS_BRAINY_SOFT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FileIcon5 />
      </Box>
    ),
    title: 'Создать ДДС на приход',
    subtitle: '',
    labelConfirm: 'Создать',
    color: 'primary',
    maxWidth: 'md'
  },
  ADD_DETAILS: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FileIcon5 />
      </Box>
    ),
    title: 'Добавить реквизиты',
    subtitle: '',
    labelConfirm: 'Добавить',
    color: 'primary',
    maxWidth: 'md'
  },
  CHANGE_ISSUE_DATE_ACCOUNTANT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <CalendarCheck />
      </Box>
    ),
    title: 'Изменить дату выдачи',
    subtitle: 'Вы точно хотите изменить дату выдачи?',
    labelConfirm: 'Изменить',
    color: 'primary'
  },
  CHANGE_ISSUE_DATE_MANAGER: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <CalendarCheck />
      </Box>
    ),
    title: 'Изменить дату выдачи',
    subtitle: '',
    labelConfirm: 'Изменить',
    color: 'primary'
  },
  SEND_FOR_REVISION_ACCOUNTANT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FlipBackward />
      </Box>
    ),
    title: 'Отправить на доработку',
    subtitle: '',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  SEND_FOR_REVISION_COLLATERAL_DOCS: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FlipBackward />
      </Box>
    ),
    title: 'Отправить на доработку',
    subtitle: '',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  SEND_FOR_REVISION_BANK_DOCS: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <FlipBackward />
      </Box>
    ),
    title: 'Отправить на доработку',
    subtitle: '',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  CREATE_CONTRACT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[50] }}>
        <CheckCircleIcon color="success" />
      </Box>
    ),
    title: 'Создать контракт',
    subtitle: 'Это действие нельзя будет отменить ',
    labelConfirm: 'Создать',
    color: 'primary'
  },
  APPROVE_ON_FINANCING: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[50] }}>
        <CheckCircleIcon color="success" />
      </Box>
    ),
    title: 'Отправить на финансирование',
    subtitle: 'Это действие нельзя будет отменить ',
    labelConfirm: 'К выдаче',
    color: 'primary'
  },
  SEND_TO_PROMOTE: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[50] }}>
        <CheckCircleIcon color="success" />
      </Box>
    ),
    title: 'Отправить на проверку',
    subtitle: 'Это действие нельзя будет отменить ',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  SEND_TO_FINAL_CHECK: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[50] }}>
        <CheckCircleIcon color="success" />
      </Box>
    ),
    title: 'Отправить на финальную проверку',
    subtitle: 'Это действие нельзя будет отменить ',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  SUBMIT_FOR_SIGN_BY_DEALER: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: INFO_COLORS[600] }}>
        <ArrowCircleBrokenRight />
      </Box>
    ),
    title: 'Отправить документы',
    subtitle: 'Документы будут отправлены дилеру на подписание',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  SUBMIT_FOR_REVIEW: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[600] }}>
        <ArrowCircleBrokenRight />
      </Box>
    ),
    title: 'Отправить на проверку',
    subtitle: 'Документы будут отправлены на проверку',
    labelConfirm: 'Отправить',
    color: 'primary'
  },
  CLIENT_CONSIDERING: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <AvTimer />
      </Box>
    ),
    title: 'Ожидание клиента',
    subtitle: 'Клиент будет переведён в статус ожидания',
    labelConfirm: 'Перевести',
    color: 'primary'
  },
  CLIENT_DECIDED: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[50] }}>
        <CheckCircleIcon color="success" />
      </Box>
    ),
    title: 'Клиент принял решение?',
    subtitle: '',
    labelConfirm: 'Подтвердить',
    color: 'primary'
  },
  UPLOAD_DOCUMENTS: {
    headTitle: 'Загрузите документы',
    title: '',
    subtitle: '',
    labelConfirm: 'Загрузить',
    color: 'primary'
  },
  ADD_COLLETERAL: {
    headTitle: 'Добавить обеспечение',
    title: '',
    subtitle: '',
    labelConfirm: 'Создать залог',
    color: 'primary',
    maxWidth: 'lg'
  },
  CAR_REPORT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <CarIcon />
      </Box>
    ),
    title: '',
    subtitle: '',
    labelConfirm: 'Подтвердить',
    color: 'primary'
  },
  CLIENT_REFUSE: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: ERROR_COLORS[100] }}>
        <SlashCircleIcon />
      </Box>
    ),
    title: 'Клиент отказывается кредитоваться?',
    subtitle: 'Это действие нельзя будет отменить',
    labelConfirm: 'Отказ',
    color: 'secondary'
  },
  CLIENT_CONSENT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <Check />
      </Box>
    ),
    title: 'Клиент согласен кредитоваться?',
    subtitle: 'Это действие нельзя будет отменить',
    labelConfirm: 'Одобрить',
    color: 'success'
  },
  REVERT: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: ERROR_COLORS[50] }}>
        <AlertCircleIcon />
      </Box>
    ),
    labelConfirm: 'Отправить',
    title: 'Указать на доработку в заявке',
    subtitle: 'Вы отправите заявку менеджеру на доработку',
    color: 'primary'
  },
  REVERT_ON_FINANCING: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: ERROR_COLORS[50] }}>
        <AlertCircleIcon />
      </Box>
    ),
    labelConfirm: 'Отправить',
    title: 'Указать на доработку в контракте',
    subtitle: 'Вы отправите контракт менеджеру на доработку',
    color: 'primary'
  },
  ALTERNATIVE: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <SwitchHorizontal />
      </Box>
    ),
    labelConfirm: 'Отправить',
    title: 'Альтернативное предложение',
    subtitle: 'Предложите клиенту новые условия для кредитования',
    color: 'primary'
  },
  CHOOSE_ALTERNATIVE: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: GRAY_COLORS[100] }}>
        <SwitchHorizontal />
      </Box>
    ),
    labelConfirm: 'Клиент согласен',
    labelCancel: 'Отказ клиента',
    cancelBtnRed: true,
    title: 'Альтернативное предложение',
    subtitle: 'Согласуйте с клиентом новые условия для кредитования',
    color: 'primary',
    maxWidth: 'md'
  },
  REFUSE: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: ERROR_COLORS[50] }}>
        <SlashCircleIcon />
      </Box>
    ),
    labelConfirm: 'Отказать',
    title: 'Отказать заявке',
    subtitle: 'Это действие нельзя будет отменить',
    color: 'secondary'
  },
  REFUSE_ON_FINANCING: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: ERROR_COLORS[50] }}>
        <SlashCircleIcon />
      </Box>
    ),
    labelConfirm: 'Отказать',
    title: 'Отказаться от контракта',
    subtitle: 'Это действие нельзя будет отменить',
    color: 'secondary'
  },
  APPROVE: {
    headTitle: (
      <Box sx={{ ...baseIconStyle, backgroundColor: SUCCESS_COLORS[50] }}>
        <CheckCircleIcon color="success" />
      </Box>
    ),
    labelConfirm: 'Одобрить',
    title: 'Одобрить заявку',
    subtitle: 'Это действие нельзя будет отменить',
    color: 'primary'
  },
  RESIGN_DOCUMENTS: {
    headTitle: 'Переподписание документов',
    title: 'Отправить запрос на переподписание?',
    subtitle: 'Клиент получит новую ссылку. Текущая версия станет недействительной после успешной подписи.',
    labelConfirm: 'Да, переподписать',
    labelCancel: 'Отмена',
    color: 'primary',
    maxWidth: 'sm'
  },
  UPLOAD_ISSUED_DOCS: {
    headTitle: 'Дозагрузка документов',
    title: 'Дозагрузка документов',
    subtitle: 'Сначала выберите группу, затем загрузите нужные файлы по типам',
    labelConfirm: 'Загрузить',
    labelCancel: 'Отмена',
    color: 'info',
    maxWidth: 'md'
  },
  DEFAULT: {
    headTitle: '',
    labelConfirm: 'Отправить',
    labelCancel: 'Отмена',
    title: '',
    subtitle: '',
    color: 'primary'
  }
}

export const roleModalWithTimerConfig = {
  UPLOAD_PAYMENT_ORDER: {
    title: 'Кредит выдан',
    descriptionEmpty: '',
    icon: <CheckCircleIcon color="success" />,
    backgroundColor: SUCCESS_COLORS[50]
  },
  CREATE_CONTRACT: {
    title: 'Контракт создан',
    descriptionEmpty: '',
    icon: <CheckCircleIcon color="success" />,
    backgroundColor: SUCCESS_COLORS[50]
  },
  APPROVE_ON_FINANCING: {
    title: 'Контракт на финансировании',
    descriptionEmpty: '',
    icon: <CheckCircleIcon color="success" />,
    backgroundColor: SUCCESS_COLORS[50]
  },
  SEND_TO_PROMOTE: {
    title: 'Отправлено',
    descriptionEmpty: '',
    icon: <CheckCircleIcon color="success" />,
    backgroundColor: SUCCESS_COLORS[50]
  },
  SEND_TO_FINAL_CHECK: {
    title: 'Отправлено на финальную проверку',
    descriptionEmpty: '',
    icon: <CheckCircleIcon color="success" />,
    backgroundColor: SUCCESS_COLORS[50]
  },
  SEND_FOR_REVISION_COLLATERAL_DOCS: {
    title: 'Контракт отправлен на доработку',
    descriptionEmpty: '',
    icon: <FlipBackward />,
    backgroundColor: GRAY_COLORS[100]
  },
  SEND_FOR_REVISION_BANK_DOCS: {
    title: 'Контракт отправлен на доработку',
    descriptionEmpty: '',
    icon: <FlipBackward />,
    backgroundColor: GRAY_COLORS[100]
  },
  SEND_FOR_REVISION_ACCOUNTANT: {
    title: 'Контракт отправлен на доработку',
    descriptionEmpty: '',
    icon: <FlipBackward />,
    backgroundColor: GRAY_COLORS[100]
  },
  APPROVE: {
    title: 'Заявка одобрена',
    descriptionEmpty: 'В очереди нет заявок',
    icon: <CheckCircleIcon color="success" />,
    backgroundColor: SUCCESS_COLORS[50]
  },
  REFUSE: {
    title: 'Заявке отказано',
    descriptionEmpty: 'В очереди нет заявок',
    icon: <SlashCircleIcon />,
    backgroundColor: ERROR_COLORS[50]
  },
  REFUSE_ON_FINANCING: {
    title: 'Контракт отклонён',
    descriptionEmpty: '',
    icon: <SlashCircleIcon />,
    backgroundColor: ERROR_COLORS[50]
  },
  ALTERNATIVE: {
    title: 'Предложение отправлено',
    descriptionEmpty: 'В очереди нет заявок',
    icon: <SwitchHorizontal />,
    backgroundColor: GRAY_COLORS[100]
  },
  REVERT: {
    title: 'Заявка отправлена на доработку',
    descriptionEmpty: 'В очереди нет заявок',
    icon: <AlertCircleIcon />,
    backgroundColor: ERROR_COLORS[50]
  },
  REVERT_ON_FINANCING: {
    title: 'Контракт отправлен на доработку',
    descriptionEmpty: '',
    icon: <AlertCircleIcon />,
    backgroundColor: ERROR_COLORS[50]
  },
  DEFAULT: {
    title: 'Ошибка',
    description: 'Произошла ошибка. Пожалуйста, обновите страницу.',
    icon: <AlertCircleIcon />,
    backgroundColor: ERROR_COLORS[50],
    buttonLabel: 'Обновить'
  }
}
